import SocialFacebook from '@monofront/design-system/visuals/Icons/Old/SocialFacebook';
import SocialInstagram from '@monofront/design-system/visuals/Icons/Old/SocialInstagram';
import SocialLinkedin from '@monofront/design-system/visuals/Icons/Old/SocialLinkedin';
import SocialTwitter from '@monofront/design-system/visuals/Icons/Old/SocialTwitter';
import SocialTikTok from '@monofront/design-system/visuals/Icons/Old/SocialTikTok';
import useLocalizedSocialsMedia from '@hooks/i18n/useLocalizedSocialsMedia';
import useI18n from '@hooks/i18n/useI18n';

import type { JSX } from "react";

interface ILink {
  ariaLabel: string;
  href: string;
  Icon: JSX.Element;
}

const SocialLinks = () => {
  const { facebook, twitter, instagram, linkedIn, tiktok } =
    useLocalizedSocialsMedia();
  const { isGermanMarket } = useI18n();

  const links: ILink[] = [
    {
      ariaLabel: 'Facebook',
      href: facebook.homepage,
      Icon: <SocialFacebook width={20} height={20} />,
    },
    {
      ariaLabel: 'Instagram',
      href: instagram.homepage,
      Icon: <SocialInstagram width={20} height={20} />,
    },
  ];

  if (!isGermanMarket) {
    links.push(
      {
        ariaLabel: 'Twitter',
        href: twitter.homepage,
        Icon: <SocialTwitter width={20} height={20} />,
      },
      {
        ariaLabel: 'Linkedin',
        href: linkedIn.homepage,
        Icon: <SocialLinkedin width={20} height={20} />,
      },
      {
        ariaLabel: 'TikTok',
        href: tiktok.homepage,
        Icon: <SocialTikTok width={20} height={20} />,
      },
    );
  }

  return (
    <>
      <div className="social-links">
        {links.map(({ Icon, ariaLabel, href }: ILink) => (
          <a
            key={ariaLabel}
            target="_blank"
            href={href}
            rel="noopener noreferrer"
            aria-label={ariaLabel}
            data-testid={`SocialLinks-go-to-${ariaLabel}`}
          >
            {Icon}
          </a>
        ))}
      </div>
      <style jsx>{`
        .social-links {
          margin-top: var(--space-5);
          display: flex;
          justify-content: center;
        }

        .social-links a {
          padding: 0 var(--space-2);
        }
      `}</style>
    </>
  );
};

export default SocialLinks;
